import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-primary-button",
  template: `
    <button (click)="pressed.emit()">
      <ng-container *ngIf="hasIcon()">
        <i-feather name="plus" class="icon"></i-feather>
      </ng-container>
      {{ label }}
    </button>
  `,
  styles: [
    `
      button {
        border: none;
        background: #fc7c1b;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        font-family: Karla;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 16px;
        text-align: center;
        color: #fefeff;
      }
    `,
    `
      button:hover {
        background: #e37018;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.23);
      }
    `,
    `
      button:active {
        background: #b05713;
        box-shadow: 0px 2px 4px transparent;
      }
    `,

    `
      button:focus {
        outline-color: transparent;
      }
    `,
    `
      button.large {
        background: #b05713;
        flex: 1 0 100%;
      }
    `,
    `
      button.small {
        font-size: 12px;
        line-height: 12px;
      }
    `,
    `
      .icon {
        background: #b05713;
        box-shadow: 0px 2px 4px transparent;
        font-size: 12px;
        line-height: 12px;
      }
    `
  ]
})
export class PrimaryButtonComponent implements OnInit {
  @Input() size: "large" | "medium" | "small" = "large";
  @Input() label: string = "rest";
  @Input() icon: string = "";
  @Output() pressed: EventEmitter<any> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {
    console.log(this.icon);
  }

  hasIcon(): boolean {
    return this.icon.length != 0;
  }
}
